module.exports = __webpack_public_path__ + "img/temp-novel.08e150f8.svg";